import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { Request } from '@pelicargo/types';
import { useEffect } from 'react';
import { HiChevronLeft } from 'react-icons/hi2';
import { Link } from 'react-router-dom';

import { useSupportChat } from '../hooks/support/useSupportChat';

type LinkedRequestModalProps = {
  // Pick over RequireOnly due prevent weird type shenanigans
  request: Pick<Request, 'id' | 'main_request_id'>;
};

export const LinkedRequestModal = ({ request }: LinkedRequestModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { handleChatSupport } = useSupportChat({ requestId: request?.id });

  useEffect(() => {
    if (request?.main_request_id) {
      onOpen();
    } else {
      onClose();
    }
  }, [onOpen, onClose, request?.main_request_id]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} closeOnEsc={false}>
      <ModalOverlay />
      <ModalContent alignSelf="center">
        <ModalHeader>This is a duplicate request</ModalHeader>
        <ModalBody>
          <Stack>
            <Text>
              This request has been marked as duplicate and can no longer be actioned. Please make any changes or
              bookings to the main request.
            </Text>
            <Text fontSize="sm" color="text.muted">
              If you believe this is incorrect, please{' '}
              <Button onClick={handleChatSupport} variant="link" color="secondary.300" fontWeight="unset">
                contact support
              </Button>
              .
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" justify="flex-end" w="full" spacing={4}>
            <Button as={Link} to="/requests" tabIndex={-1} leftIcon={<HiChevronLeft />}>
              Requests
            </Button>
            <Button as={Link} to={`/requests/${request?.main_request_id}`} colorScheme="primary" tabIndex={0}>
              View Request
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
